<template>
  <div class="flex h-full flex-col gap-4">
    <div v-if="actionId" class="grow">
      <ClientTerminal :action-id="actionId" @close="closeTerminal" />
    </div>
    <div v-else-if="failed" class="flex grow items-center justify-center py-12">
      <div class="text-center">
        <i class="fa-solid fa-triangle-exclamation text-warning mb-4 text-3xl"></i>
        <div class="text-base-content/80 mb-2 text-lg font-medium">
          Terminal bị vô hiệu hóa
        </div>
        <div class="text-base-content/60 mb-4 text-sm">
          Tính năng terminal tương tác chưa được bật cho agent này. Hãy bật ở
          phần Cài đặt rồi thử lại.
        </div>
        <button class="btn btn-primary" @click="retry">
          Thử lại
        </button>
      </div>
    </div>
    <div v-else-if="creating" class="flex grow items-center justify-center py-12">
      <div class="text-center">
        <span class="loading loading-spinner text-primary mb-4"></span>
        <div class="text-base-content/80 mb-2 text-lg font-medium">
          Terminal tương tác...
        </div>
        <div class="text-base-content/60 text-sm">
          Agent sẽ nhận yêu cầu và kết nối tự động
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { ClientTerminal } from "@/components/ClientDetail/Terminal";
import { axios_instance } from "@/api/api";

const router = useRouter();
const actionId = ref("");
const creating = ref(false);
const failed = ref(false);

onMounted(createSession);

async function createSession() {
  const clientId = router.currentRoute.value.params.client_id as string;
  if (!clientId || creating.value) return;

  actionId.value = "";
  failed.value = false;
  creating.value = true;
  try {
    const { data } = await axios_instance.post("/api/v1/view/terminal/", {
      agent_id: clientId,
    });
    if (!data.action_id) throw new Error("Missing terminal action ID");
    actionId.value = data.action_id;
  } catch {
    failed.value = true;
  } finally {
    creating.value = false;
  }
}

function retry() {
  void createSession();
}

function closeTerminal() {
  router.back();
}
</script>
